import { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { XCircle, Loader2 } from 'lucide-react';

const API_URL = (import.meta as any).env?.VITE_API_URL || 'https://app.tahc.ai';

export default function AcceptInvite() {
  const { token } = useParams<{ token: string }>();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    loadInviteDetails();
  }, [token]);

  const loadInviteDetails = async () => {
    try {
      const res = await fetch(`${API_URL}/api/team/invite/${token}`);
      const data = await res.json();

      if (data.success) {
        const invitation = data.invitation;

        // Redirect based on whether user exists
        if (invitation.user_exists) {
          // User exists - redirect to login
          navigate(`/login?invite_token=${token}`);
        } else {
          // User doesn't exist - redirect to register
          navigate(`/register?invite_token=${token}`);
        }
      } else {
        setError(data.error || 'Invalid invitation');
        setLoading(false);
      }
    } catch (err) {
      console.error('Error loading invite:', err);
      setError('Failed to load invitation details');
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-gray-50 via-white to-gray-100 flex items-center justify-center p-4">
        <div className="bg-white rounded-2xl shadow-xl p-8 max-w-md w-full text-center">
          <Loader2 className="w-12 h-12 text-black animate-spin mx-auto mb-4" />
          <p className="text-gray-600">Loading invitation...</p>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-gray-50 via-white to-gray-100 flex items-center justify-center p-4">
        <div className="bg-white rounded-2xl shadow-xl p-8 max-w-md w-full text-center">
          <div className="w-16 h-16 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-6">
            <XCircle className="w-10 h-10 text-red-600" />
          </div>
          <h1 className="text-2xl font-bold text-gray-900 mb-2">Invalid Invitation</h1>
          <p className="text-gray-600 mb-6">
            {error}
          </p>
          <button
            onClick={() => navigate('/login')}
            className="px-6 py-2 bg-black text-white rounded-lg hover:bg-gray-800 transition-colors"
          >
            Go to Login
          </button>
        </div>
      </div>
    );
  }

  return null;
}
